/* CreateOdmOsPlanAction.js */

"use strict";
const _ = require("lodash");
const CreatePlanComponent = require("./CreateOsPlanComponent");
const Registrations = require("../../../../../RegistrationNamespaces");

class CreateOdmOsPlanAction {
    constructor(
        logger,
        gameEditor,
        modalUserFeedback,
        OdmOsUpgradePlan,
        userSession,
        activeView,
        storageFactory,
        solutionsManager
    ) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._osPlan = new OdmOsUpgradePlan(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedDeviceIds = this._activeView.getSelectedDeviceIds().selectedRows || [];
        }
        this.run = this.run.bind(this);
        this._sessionStorage = undefined;
        this._storageFactory = storageFactory;
        this._solutionsManager = solutionsManager;
        this._solutionName =
            (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "osUpgradeExplorer";
    }
    run() {
        return this._modalUserFeedback
            .displayCustom(new CreatePlanComponent(this._logger), {dontHide: true})
            .then((result) => {
                this._modalUserFeedback.displayLoading();
                return this._createPlan(result.trim(), this._selectedDeviceIds)
                    .then((resEntity) => {
                        return Promise.resolve(resEntity);
                    })
                    .catch((err) => {
                        this._logger.warn(
                            {error: err},
                            "CreateOdmOsPlanAction._createFormPlan() error."
                        );
                        return this._modalUserFeedback.displayError(err);
                    });
            })
            .then((results) => {
                this._sessionStorage = this._storageFactory.getSessionStorageInstance(
                    "entity_grid_gl",
                    `${this._gridKey}_explorerState`
                );
                return Promise.resolve(results);
            })
            .then((result) => {
                let selectedIds = [result.id];
                this._sessionStorage.setData(
                    {selectedRows: selectedIds, isFrom: "Device Explorer"},
                    "selectedIds"
                );
                this._gameEditor.openLMRBExplorer(Registrations.IOT_OS_PLAN_EXPLORER_LMRB);
                /*document
                .querySelector(
                    '[data-id="App.GameConsole.Section.GameCenter.EntityLmrbComponents.OsPlanExplorer"]'
                )
                .click();*/
            })
            .catch((err) => {
                this._modalUserFeedback.hideDisplayed();
                this._logger.warn(
                    {error: err},
                    "CreateOdmOsPlanAction.run() - Either error or cancellation"
                );
            });
    }
    _createPlan(name, deviceIds) {
        this._osPlan.name = name;
        this._osPlan.description = "";
        if (Array.isArray(deviceIds) && deviceIds.length > 0) {
            deviceIds.forEach((id) => {
                this._osPlan.addToDevicesRelationship(id);
            });
        }

        return this._osPlan.create();
    }
}
module.exports = CreateOdmOsPlanAction;

CreateOdmOsPlanAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.OdmOsUpgradePlan",
    "$teve.userSession",
    "gameEditor.activeView",
    "$teve.storageFactory",
    "$teve.solutionsManager",
];

CreateOdmOsPlanAction.$displayDetails = {
    type: "Action",
    name: "CreateOdmOsPlanAction",
    icon: "osmanager.add_os_plan",
    shown: true,
    title: "Add OS Plan",
    order: 1,
};
